// extracted by mini-css-extract-plugin
export default {"not-found":"NotFound_not-found__wlz6k","not-found__message":"NotFound_not-found__message__AnGop"};